import React, { useState, useRef, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Button,
  Avatar,
  Box,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Divider,
  Card,
  CardContent,
  TextField,
  Slide,
  DialogActions,
  DialogContentText,
  Dialog as MuiDialog,
  Collapse,
  Skeleton,
  MenuItem,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import {
  Close,
  ChevronLeft,
  ChevronRight,
  Delete,
  Add,
  Remove,
  CardTravel,
  Search,
  Clear,
  Save,
  PostAdd,
} from "@mui/icons-material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Badge from "@mui/material/Badge";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { useTheme, useMediaQuery } from "@mui/material";
import moment from "moment";
import { fAlertToast } from "../../../Utility/Utilitys";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ConfirmationDialog = ({ open, onClose, onConfirm }) => (
  <MuiDialog open={open} onClose={onClose}>
    <DialogTitle>Confirm Removal</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Are you sure you want to remove this item from the cart?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button
        onClick={onClose}
        sx={{
          backgroundColor: "#e0e0e0",
          color: "#000",
          fontWeight: "bold",
          transition: "all 0.3s ease",
          "&:hover": {
            backgroundColor: "#bdbdbd",
            transform: "scale(1.05)",
          },
        }}
      >
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        sx={{
          backgroundColor: "#f44336",
          color: "#fff",
          fontWeight: "bold",
          transition: "all 0.3s ease",
          "&:hover": {
            backgroundColor: "#d32f2f",
            transform: "scale(1.05)",
          },
        }}
      >
        Remove
      </Button>
    </DialogActions>
  </MuiDialog>
);

const CartModal = ({
  open,
  handleClose,
  mode,
  location,
  User,
  selectedRow,
  table,
}) => {
  const theme = useTheme();

  const isTabletOrBelow = useMediaQuery(theme.breakpoints.down("md"));

  const defaultImageURL = "https://via.placeholder.com/150"; // Default image URL
  const [sidebarVisible, setSidebarVisible] = useState(!isTabletOrBelow);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [categoryDetails, setCategoryDetails] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedCategoryDetails, setSelectedCategoryDetails] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSpinner, setIsLoadingSpinner] = useState(false);
  const [visibleItems, setVisibleItems] = useState(30);
  const containerRef = useRef(null);
  const [searchText, setSearchText] = useState("");

  const scrollRef = useRef(null);
  const scrollBy = 300;

  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        loadMoreItems();
      }
    };

    const currentRef = containerRef.current;
    if (currentRef) {
      currentRef.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener("scroll", handleScroll);
      }
    };
  }, [selectedCategoryDetails, visibleItems, isLoading]);
  useEffect(() => {
    getCategoryDetails();
  }, []);
  const loadMoreItems = () => {
    if (visibleItems >= selectedCategoryDetails.length) return; // Already all loaded
    setIsLoading(true);
    setTimeout(() => {
      setVisibleItems((prev) =>
        Math.min(prev + 10, selectedCategoryDetails.length)
      );
      setIsLoading(false);
    }, 0); // simulate loading delay
  };

  const handleQuantityChange = (name2, delta) => {
    setCartItems((prev) => {
      const updatedItems = [...prev];
      const itemIndex = updatedItems.findIndex((item) => item.Name2 === name2);

      if (itemIndex === -1) return prev;

      const item = updatedItems[itemIndex];
      const newQty = item.OrderQty + delta;

      // In "add" mode: allow decrease to 0 and remove item
      if (mode === "add") {
        if (newQty <= 0) {
          updatedItems.splice(itemIndex, 1); // Remove item
          return updatedItems;
        }

        item.OrderQty = newQty;
        updatedItems[itemIndex] = item;
        return updatedItems;
      }

      // In "edit" mode: prevent going below 1
      if (newQty < 1) return prev;

      // Handle decrease logic with reason
      if (delta < 0) {
        if (
          item.isFromDB &&
          item.showReasonDropdown !== true &&
          !item.reduceNarration
        ) {
          item.showReasonDropdown = true;
          item.reasonRequired = true;
          return updatedItems;
        }

        if (item.showReasonDropdown && !item.reduceNarration) {
          item.reasonRequired = true;
          return updatedItems;
        }

        item.OrderQty = newQty;
        item.reasonRequired = false;
      }

      // Handle increase
      if (delta > 0) {
        item.OrderQty = newQty;
        if (item.isFromDB) {
          item.showReasonDropdown = false;
          item.reduceNarration = "";
        }
      }

      updatedItems[itemIndex] = item;
      return updatedItems;
    });
  };

  const handleDelete = (index) => {
    setDeleteIndex((prev) => (prev === index ? null : index));
  };

  const confirmDelete = () => {
    setCartItems((prev) => prev.filter((_, i) => i !== deleteIndex));
    setDeleteIndex((prev) => null);
  };

  const handleReasonChange = (index, reason) => {
    setCartItems((prev) => {
      const newItems = [...prev];
      const item = newItems[index];
      item.reduceNarration = reason;
      item.reasonRequired = !reason.trim();

      // If a valid reason is selected, decrease quantity immediately
      if (reason.trim()) {
        const newQty = item.OrderQty - 1;
        if (newQty >= 1) {
          item.OrderQty = newQty;
          item.showReasonDropdown = false; // hide dropdown after action
          item.reasonRequired = false;
        }
      }

      return newItems;
    });
  };

  const subtotal = cartItems.reduce(
    (acc, item) => acc + item.OrderQty * item.VATRSP,
    0
  );

  const toggleSidebar = () => setSidebarVisible((prev) => !prev);

  const handleCart = (item) => {
    setCartItems((prev) => [...prev, { ...item, OrderQty: 1 }]);
  };
  const resetState = () => {
    setSidebarVisible((prev) => !prev);
    setDeleteIndex((prev) => null);
    setSelectedCategory(null);
    setSelectedCategoryDetails([]);
    setCartItems([]);
    handleClose();
  };

  const getCategoryDetails = async () => {
    try {
      setIsLoadingSpinner(true);
      const response = await fetch(
        `http://178.23.187.46:3038/QuickSale/INV06TO_Main_Category_GetRow`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            Loc: location,
          }),
        }
      );
      if (response.ok) {
        const responseData = await response.json();

        const categories = responseData.ResultSet.map((cat) => ({
          ...cat,
          image: defaultImageURL, // Use default image if not provided
        }));
        setCategoryDetails((prev) => [...prev, ...categories]);
        await getSelectedCategoryDetails(categories[0].Cd);
      }
    } catch (error) {
      console.error("Error fetching category details:", error);
    } finally {
      setIsLoadingSpinner(false);
    }
  };
  const getSelectedCategoryDetails = async (category) => {
    try {
      setIsLoadingSpinner(true);
      setSelectedCategory((prev) => category);
      setSelectedCategoryDetails([]);

      const response = await fetch(
        `http://178.23.187.46:3038/QuickSale/INV06TO_QuickSales_Items_GetRow`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            Grp: category,
            Loc: location,
            SearchText: searchText.trim(),
          }),
        }
      );
      if (response.ok) {
        const rawData = await response.json();

        const updatedCategoryDetails = rawData.ResultSet.map((item) => {
          // if (item.Stock >= 0) {
          return {
            ...item,
            // Stock: parseInt(Math.random() * 10),
            image: defaultImageURL,
            //Unit: parseInt(Math.random() * 100),
            isFromDB: false,
            OrderQty: 0,
            reduceQty: 0,
            reduceNarration: "",
            FinalQty: 0,
            LandValue: 0,
          };
          // }
        });
        setSelectedCategoryDetails((prev) => [
          ...prev,
          ...updatedCategoryDetails,
        ]);
        if (mode === "edit" && selectedRow?.A_Transid) {
          cartDetailGet(updatedCategoryDetails);
        }
        // setSelectedCategoryDetails(rawData.ResultSet);
      }
    } catch (error) {
      console.error("Error fetching category details:", error);
    } finally {
      setIsLoadingSpinner(false);
    }
  };
  const cartDetailGet = async (categoryDetailArr) => {
    try {
      setIsLoadingSpinner(true);
      const payload = {
        Transid: selectedRow.A_Transid,
      };
      const response = await fetch(
        "http://178.23.187.46:3038/QuickSale/INV06TOB_Getrow",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        const data = await response.json();

        const cartData = data.ResultSet?.map((item) => {
          const matchedCategory = categoryDetailArr.find(
            (catItem) => catItem.Name2 === item.ItemName
          );

          return {
            ...item,
            image: defaultImageURL,
            OrderQty: item.B_OrderQty,
            reduceQty: item.B_ReduceQty,
            reduceNarration: item.B_ReduceReason,
            Name2: item.ItemName,
            Unit: item.B_Unitrate,
            isFromDB: true,
            BarCode: item.B_Barcode,
            Packing: item.B_Unit,
            ItmCd: item.B_Itemcd,
            Unitrate: item.B_Unitrate,
            FinalQty: item.B_FinalQty,
            RSP: matchedCategory?.RSP ?? item.B_RSP,
            VATRSP: matchedCategory?.VATRSP ?? item.B_VATRSP,
          };
        });

        setCartItems(cartData);

        setSelectedCategoryDetails((prev) => {
          const updatedItems = [...prev];
          cartData.forEach((cartItem) => {
            const index = updatedItems.findIndex(
              (item) => item.Name2 === cartItem.Name2
            );
            if (index !== -1) {
              updatedItems[index].isFromDB = true; // Mark as from DB
            }
          });
          return updatedItems;
        });
      }
    } catch (error) {
      console.error("Error fetching cart details:", error);
    } finally {
      setIsLoadingSpinner(false);
    }
  };

  const postCartItems = async (isSave) => {
    try {
      const payload = {
        A_TransId: mode === "edit" ? cartItems[0].B_Transid : 0,
        A_Loc: location,
        A_Table: table,
        A_Date: moment().format("YYYY-MM-DD"),
        A_UserCd: User,
        Details: cartItems?.map((item) => ({
          ItemCd: item.ItmCd,
          Barcode: item.BarCode,
          Unit: item.Packing,
          OrderQty: item.OrderQty,
          ReduceQty: item.reduceQty,
          FinalQty: item.OrderQty - item.reduceQty,
          ReduceReason: item.reduceNarration,
          Unitrate: item.RSP,
        })),
        isApproved: isSave ? true : false,
      };
      const response = await fetch(
        "http://178.23.187.46:3038/QuickSale/INV06TO_Update",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error(`Server error: ${response.statusText}`); // Better handling non-200 errors
      }

      const data = await response.json(); // Moved this line outside the if statement
      fAlertToast("SUCCESS", "Cart items posted successfully!");
      resetState(); // Reset state after successful post
    } catch (error) {
      fAlertToast("FAILED", error.message);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        resetState();
      }}
      fullScreen
      TransitionComponent={Transition}
      PaperProps={{ sx: { bgcolor: "#f9f9fb" } }}
    >
      <DialogContent
        sx={{
          display: "flex",
          height: "100%",
          overflow: "hidden",
          padding: "6px 24px",
        }}
      >
        {/* LEFT CART SIDEBAR */}

        {sidebarVisible && (
          <Box
            sx={{
              position: isTabletOrBelow ? "fixed" : "relative",
              top: 0,
              left: 0,
              width: isTabletOrBelow ? "100%" : 420,
              height: "100%",
              bgcolor: "background.paper",
              boxShadow: isTabletOrBelow ? 6 : 3,
              zIndex: isTabletOrBelow ? 1300 : "auto",
              display: "flex",
              flexDirection: "column",
              transition: "all 0.3s ease",
              borderTopLeftRadius: isTabletOrBelow ? 0 : 12,
              borderBottomLeftRadius: isTabletOrBelow ? 0 : 12,
              overflow: "hidden",
            }}
          >
            {/* Header */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", p: 1 }}>
              <IconButton onClick={toggleSidebar}>
                <Close />
              </IconButton>
            </Box>

            {/* Content */}
            {cartItems.length > 0 ? (
              <>
                <Box
                  sx={{
                    flexGrow: 1,
                    overflowY: "auto",
                    px: 1.5,
                    pb: 1,
                    "&::-webkit-scrollbar": { width: 6 },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#ccc",
                      borderRadius: 3,
                    },
                  }}
                >
                  <List>
                    {cartItems?.map((item, index) => (
                      <ListItem
                        key={`${item.ItmCd}-${index}`}
                        sx={{
                          mb: 1.5,
                          borderRadius: 2,
                          boxShadow: 2,
                          px: 1.5,
                          py: 1.5,
                          bgcolor: "#fff",
                          flexDirection: "column",
                          border: "1px solid #e0e0e0",
                        }}
                      >
                        {/* Item Row */}
                        <Box
                          display="flex"
                          width="100%"
                          alignItems="center"
                          gap={1}
                        >
                          <Avatar
                            variant="rounded"
                            src={item.image}
                            sx={{ width: 48, height: 48 }}
                          />
                          <Box flexGrow={1}>
                            <Typography fontWeight={600} fontSize="0.95rem">
                              {item.Name2}
                            </Typography>
                            <Typography
                              variant="body2"
                              fontSize="0.85rem"
                              color="text.secondary"
                            >
                              {item.OrderQty} x {item.VATRSP} ={" "}
                              {(item.OrderQty * item.VATRSP).toFixed(2)} AED
                            </Typography>
                            <Box
                              mt={0.8}
                              display="flex"
                              alignItems="center"
                              gap={1}
                              justifyContent="start"
                            >
                              <Button
                                size="small"
                                variant="outlined"
                                sx={{ minWidth: 30, py: 0.5 }}
                                disabled={item.isFromDB}
                                onClick={() =>
                                  handleQuantityChange(item.Name2, -1)
                                }
                              >
                                <Remove fontSize="small" />
                              </Button>
                              <Typography
                                fontWeight="medium"
                                minWidth={28}
                                textAlign="center"
                                variant="body1"
                              >
                                {item.OrderQty}
                              </Typography>
                              <Button
                                size="small"
                                variant="outlined"
                                sx={{ minWidth: 30, py: 0.5 }}
                                onClick={() =>
                                  handleQuantityChange(item.Name2, 1)
                                }
                              >
                                <Add fontSize="small" />
                              </Button>
                            </Box>
                          </Box>
                          <IconButton
                            onClick={() => handleDelete(index)}
                            color="error"
                          >
                            <Delete />
                          </IconButton>
                        </Box>

                        {/* Edit Reason */}
                        {mode === "edit" && item.isFromDB && (
                          <Collapse in={true} sx={{ width: "100%" }}>
                            <Box
                              mt={1.5}
                              display="flex"
                              alignItems="center"
                              justifyContent={
                                item.showReasonDropdown
                                  ? "space-between"
                                  : "center"
                              }
                              gap={1}
                            >
                              {item.showReasonDropdown && (
                                <TextField
                                  select
                                  label="Reason"
                                  size="small"
                                  fullWidth
                                  sx={{ flexGrow: 1 }}
                                  value={item.reduceNarration}
                                  onChange={(e) =>
                                    handleReasonChange(index, e.target.value)
                                  }
                                  error={
                                    item.reasonRequired && !item.reduceNarration
                                  }
                                  helperText={
                                    item.reasonRequired && !item.reduceNarration
                                      ? "Required"
                                      : ""
                                  }
                                >
                                  {[
                                    "  ",
                                    "Not tasty",
                                    "Not fresh",
                                    "Overcooked",
                                    "Wrong item prepared",
                                    "Customer rejected",
                                    "Damaged during preparation",
                                    "Expired",
                                    "Other",
                                  ]?.map((reason) => (
                                    <MenuItem key={reason} value={reason}>
                                      {reason}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              )}
                              <Button
                                size="small"
                                variant="contained"
                                color="error"
                                onClick={() =>
                                  handleQuantityChange(item.Name2, -1)
                                }
                                sx={{
                                  minWidth: "fit-content",
                                  fontSize: "0.75rem",
                                  py: 0.3,
                                  px: 1,
                                }}
                              >
                                Decrease Qty
                              </Button>
                            </Box>
                          </Collapse>
                        )}
                      </ListItem>
                    ))}
                  </List>
                </Box>

                {/* Subtotal & Checkout */}
                <Box
                  sx={{ p: 1.5, borderTop: "1px solid #eee", bgcolor: "#fff" }}
                >
                  <Box display="flex" justifyContent="space-between" mb={1}>
                    <Typography variant="subtitle1" fontSize="1rem">
                      Total
                    </Typography>
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      fontSize="1.2rem"
                    >
                      {subtotal.toFixed(2)} AED
                    </Typography>
                  </Box>
                  <Box display="flex" gap={1.5}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      startIcon={<Save />}
                      size="large"
                      sx={{ fontWeight: 600, py: 1 }}
                      disabled={cartItems.length === 0}
                      onClick={() => postCartItems(false)}
                    >
                      Save
                    </Button>
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      startIcon={<PostAdd />}
                      size="large"
                      sx={{ fontWeight: 600, py: 1 }}
                      disabled={cartItems.length === 0}
                      onClick={() => postCartItems(true)}
                    >
                      Post
                    </Button>
                  </Box>
                </Box>
              </>
            ) : (
              <Box
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  px: 3,
                }}
              >
                <ShoppingCartOutlinedIcon
                  sx={{ fontSize: 80, color: "grey.400", mb: 2 }}
                />
                <Typography variant="h6" color="text.secondary" gutterBottom>
                  Your cart is empty
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Start adding items to see them here.
                </Typography>
              </Box>
            )}
          </Box>
        )}

        {/* RIGHT SECTION */}
        <Box
          sx={{
            width: sidebarVisible ? "78%" : "100%",
            pl: 2,
            display: "flex",
            flexDirection: "column",
            bgcolor: "#f5f7fb",
          }}
        >
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "8px 16px",
            }}
          >
            {/* Left side: Cart Toggle */}
            <Box sx={{ width: 48 }}>
              {!sidebarVisible && (
                <IconButton onClick={toggleSidebar}>
                  <Badge
                    badgeContent={cartItems.length}
                    color="primary"
                    showZero
                  >
                    <ShoppingCartIcon />
                  </Badge>
                </IconButton>
              )}
            </Box>

            {/* Center: Title and Search side-by-side */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flex: 1,
                justifyContent: "space-evenly",
                gap: 2,
              }}
            >
              <Typography variant="h6" sx={{ whiteSpace: "nowrap" }}>
                {mode === "add" ? "Add Items" : "Edit Items"}
              </Typography>

              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <TextField
                  size="small"
                  variant="outlined"
                  placeholder="Search products..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  sx={{ width: 200 }}
                  InputProps={{
                    endAdornment: searchText && (
                      <IconButton
                        size="small"
                        onClick={() => setSearchText("")}
                      >
                        <Clear />
                      </IconButton>
                    ),
                  }}
                />
                <IconButton
                  color="primary"
                  onClick={() => getSelectedCategoryDetails(selectedCategory)}
                >
                  <Search />
                </IconButton>
              </Box>
            </Box>

            {/* Right side: Close Button */}
            <Box
              sx={{ width: 48, display: "flex", justifyContent: "flex-end" }}
            >
              <IconButton onClick={handleClose}>
                <Close />
              </IconButton>
            </Box>
          </DialogTitle>

          {/* Category Section */}
          {/* Category Section */}
          <Box
            sx={{
              position: "relative",
              py: 1,
              px: 2,
              mb: 2,
              bgcolor: "#e0f7fa",
              boxShadow: 1,
              borderRadius: 2,
            }}
          >
            {/* Left Scroll Button */}
            <IconButton
              onClick={() =>
                scrollRef.current.scrollBy({
                  left: -scrollBy,
                  behavior: "smooth",
                })
              }
              sx={{
                position: "absolute",
                top: "30%",
                left: -20,
                zIndex: 1,
                bgcolor: "blue", // Blue background
                color: "white", // Icon color
                boxShadow: 2,
                ":hover": {
                  bgcolor: "#1565c0", // Darker blue on hover
                },
              }}
            >
              <ChevronLeft />
            </IconButton>

            {/* Scrollable Category Box */}
            {categoryDetails.length > 0 ? (
              <Box
                ref={scrollRef}
                sx={{
                  display: "flex",
                  gap: 2,
                  overflowX: "auto",
                  px: 4,
                  pb: 1,
                  scrollbarWidth: "none", // Firefox
                  msOverflowStyle: "none", // IE & Edge
                  "&::-webkit-scrollbar": {
                    display: "none", // Chrome, Safari
                  },
                }}
              >
                {categoryDetails?.map((cat, index) => (
                  <Box
                    key={index}
                    sx={{
                      textAlign: "center",
                      minWidth: 90,
                      flexShrink: 0,
                      transition: "transform 0.2s",
                      transformOrigin: "center center", // <-- Add this
                      display: "flex", // <-- Add these
                      flexDirection: "column", // for vertical alignment
                      alignItems: "center",
                      cursor: "pointer",

                      zIndex: 1,
                      padding: 1,
                      "&:hover": { transform: "scale(1.08)" },
                      bgcolor:
                        selectedCategory === cat.Cd ? "#b2ebf2" : "transparent",
                      borderRadius: 2,
                    }}
                    onClick={() => getSelectedCategoryDetails(cat.Cd)}
                  >
                    <Avatar
                      src={cat.image}
                      alt={cat.Name1}
                      sx={{
                        width: 64,
                        height: 64,
                        margin: "auto",
                        mb: 1,
                        border: "2px solid #bbb",
                      }}
                    />
                    <Typography variant="caption" fontWeight={500}>
                      {cat.Name1}
                    </Typography>
                  </Box>
                ))}
              </Box>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                {"Categories not available"}
              </Box>
            )}

            {/* Right Scroll Button */}
            <IconButton
              onClick={() =>
                scrollRef.current.scrollBy({
                  left: scrollBy,
                  behavior: "smooth",
                })
              }
              sx={{
                position: "absolute",
                top: "30%",
                right: 5,
                zIndex: 1,
                bgcolor: "blue", // Blue background
                color: "white", // Icon color
                boxShadow: 2,
                ":hover": { bgcolor: "#1565c0" }, // Darker blue on hover
              }}
            >
              <ChevronRight />
            </IconButton>
          </Box>

          {/* Products Grid Scrollable */}
          {selectedCategoryDetails.length > 0 ? (
            <Box
              ref={containerRef}
              sx={{
                flex: 1,
                overflowY: "auto",
                px: 2,
                pb: 2,
                "&::-webkit-scrollbar": {
                  width: "6px",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#aaa",
                  borderRadius: "6px",
                },
              }}
            >
              <Box
                sx={() => ({
                  display: "grid",
                  gap: 3,
                  justifyContent: "center",
                  gridTemplateColumns: {
                    xs: "repeat(auto-fill, minmax(160px, 1fr))",
                    sm: "repeat(3, 1fr)",
                    md: "repeat(3, 1fr)", // force 3 for tablets and medium screens
                    lg: sidebarVisible ? "repeat(4, 1fr)" : "repeat(5, 1fr)",
                  },
                })}
              >
                {selectedCategoryDetails
                  .slice(0, visibleItems)
                  ?.map((item, index) => (
                    <Card
                      key={`item-${index}-${item.Name2}`}
                      sx={{
                        width: "100%",
                        transition: "transform 0.3s, box-shadow 0.3s",
                        "&:hover": { transform: "scale(1.05)", boxShadow: 6 },
                      }}
                    >
                      <CardContent
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          height: "100%",
                        }}
                      >
                        <Avatar
                          variant="rounded"
                          src={item.image}
                          sx={{ width: "100%", height: 100, mb: 1 }}
                        />
                        <Typography
                          fontWeight="bold"
                          color="primary.main"
                          align="center"
                          noWrap
                          sx={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            display: "block",
                            width: "100%",
                          }}
                        >
                          {item.Name2}
                        </Typography>
                        <Typography
                          variant="body2"
                          align="center"
                          sx={{
                            fontSize: 13,
                            color: "text.secondary",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            mx: "auto",
                            width: "100%",
                            maxWidth: "100%",
                            lineHeight: 1.4,
                          }}
                        >
                          {item.BarCode || "—"}
                        </Typography>

                        <Box
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          mt={1}
                          mb={1}
                        >
                          <Typography fontWeight="bold" mt={1}>
                            Price: {item.VATRSP.toFixed(2)} AED
                          </Typography>
                          <Typography fontSize={13} color="gray">
                            Qty: {item.Stock}
                          </Typography>
                        </Box>
                        <Box sx={{ flexGrow: 1 }} />

                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          gap={1}
                          mt={2}
                        >
                          {/* Minus Button */}
                          <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            sx={{ minWidth: 32, px: 0 }}
                            disabled={
                              item.isFromDB ||
                              !cartItems.some(
                                (cartItem) => cartItem.Name2 === item.Name2
                              )
                            }
                            onClick={() => handleQuantityChange(item.Name2, -1)}
                          >
                            <Remove fontSize="small" />
                          </Button>

                          {/* Add to Cart / Already Added Button */}
                          <Button
                            variant="contained"
                            color={
                              cartItems.some(
                                (cartItem) => cartItem.Name2 === item.Name2
                              )
                                ? "inherit"
                                : "success"
                            }
                            sx={{ flexGrow: 1, px: 1 }} // allow it to grow within available space
                            onClick={() => handleCart(item)}
                            disabled={cartItems.some(
                              (cartItem) => cartItem.Name2 === item.Name2
                            )}
                            startIcon={<CardTravel />}
                          >
                            {cartItems.some(
                              (cartItem) => cartItem.Name2 === item.Name2
                            )
                              ? {
                                  ...cartItems.find(
                                    (cartItem) => cartItem.Name2 === item.Name2
                                  ),
                                  OrderQty: cartItems.find(
                                    (cartItem) => cartItem.Name2 === item.Name2
                                  ).OrderQty,
                                }.OrderQty
                              : "Add to Cart"}
                          </Button>

                          {/* Plus Button */}
                          <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            sx={{ minWidth: 32, px: 0 }}
                            onClick={() => handleQuantityChange(item.Name2, 1)}
                            disabled={
                              !cartItems.some(
                                (cartItem) => cartItem.Name2 === item.Name2
                              )
                            }
                          >
                            <Add fontSize="small" />
                          </Button>
                        </Box>
                      </CardContent>
                    </Card>
                  ))}

                {isLoading &&
                  Array.from({ length: 6 }).map((_, index) => (
                    <Card
                      key={`skeleton-${index}`}
                      sx={{
                        width: "100%",
                        height: 300,
                        display: "flex",
                        flexDirection: "column",
                        p: 2,
                      }}
                    >
                      <Skeleton
                        variant="rectangular"
                        width="100%"
                        height={100}
                      />
                      <Skeleton variant="text" height={30} sx={{ mt: 2 }} />
                      <Skeleton
                        variant="text"
                        width="80%"
                        height={20}
                        sx={{ mt: 1 }}
                      />
                      <Skeleton
                        variant="text"
                        width="60%"
                        height={20}
                        sx={{ mt: 1 }}
                      />
                      <Skeleton
                        variant="rectangular"
                        width="100%"
                        height={36}
                        sx={{ mt: "auto" }}
                      />
                    </Card>
                  ))}
              </Box>
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              {"Products not available"}
            </Box>
          )}
        </Box>
      </DialogContent>

      {deleteIndex !== null && (
        <ConfirmationDialog
          open={true}
          onClose={() => setDeleteIndex(null)}
          onConfirm={confirmDelete}
        />
      )}

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoadingSpinner}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  );
};
export default CartModal;
